export default __webpack_public_path__ + "graphics/villa.e307dff0.jpg";